<template>
  <div class="container" v-if="!loading && isResult">
    <div class="header">
      <img
        class="bg"
        src="https://oss.turingsenseai.com/1722305786355799696.jpg"
        alt=""
        srcset=""
      />
    </div>
    <div class="topcard">
      <img
        class="zhi"
        src="https://oss.turingsenseai.com/1722306020872762857.jpg"
      />
      <span>首次查询时间：{{ jdReportDetail.firstVisitTime || "-" }}</span>
      <span>{{`查询次数：此鉴定码已被查询验证${ jdReportDetail.visitNums || 1 }次`}}</span>
      <span>最后查询时间：{{ jdReportDetail.lastVisitTime || dateFormat() }}</span>
    </div>
    <div class="content">
      <div class="title">
        <img src="https://oss.turingsenseai.com/1719544638458427561.jpg"/>
      </div>
      <div class="main">
        <img
          class="mark"
          :src="
            [
              '',
              'https://oss.turingsenseai.com/1719552188748479622.jpg',
              'https://oss.turingsenseai.com/1719913749695660924.jpg',
              'https://oss.turingsenseai.com/1722306564816518866.jpg',
              'https://oss.turingsenseai.com/1727259407903212079.jpg'
            ][jdReportDetail.result]
          "/>
        <div class="item mb36">
          <div class="label mb24">
            <span class="icon"></span>
            <span class="des-name">品类/品牌/品名/规格型号</span>
          </div>
          <div class="value">
            <span class="true-value">{{ kindBrandSeries }}</span>
          </div>
        </div>
        <div class="item mb36">
          <div class="label mb24">
            <span class="icon"></span>
            <span class="des-name">证书编号</span>
          </div>
          <div class="value">
            <span class="true-value">{{ jdReportDetail.certNo || "-" }}</span>
          </div>
        </div>
        <div class="item mb36">
          <div class="label mb24">
            <span class="icon"></span>
            <span class="des-name">批次号</span>
          </div>
          <div class="value">
            <span class="true-value">{{ jdReportDetail.batchCode || "-" }}</span>
          </div>
        </div>
        <div class="item">
          <div class="label">
            <span class="icon"></span>
            <span class="des-name">鉴定图片</span>
          </div>
          <div class="value">
            <div class="true-value">
              <img
                @click="previewImage(i)"
                v-for="(url, i) in imageList"
                :key="url"
                :src="url + '?x-oss-process=image/resize,h_700,w_700'"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="desc">上述鉴定结果由北京中认检测技术服务有限公司支持</div>
    </div>
    <!-- <div class="footer">信息系统服务由图灵鉴定提供支持</div> -->
    <div class="footer" v-if="appraiserDate.year">{{ `本报告于${appraiserDate.year}年${appraiserDate.month}月${appraiserDate.day}日出具，有效期90天` }}</div>
  </div>
  <div class="no-result" v-else>
    <van-loading v-if="loading" size="60">加载中...</van-loading>
    <div class="empty" v-else>
      <img class="null-img" src="https://oss.turingsenseai.com/1722581182806982453.jpg">
      <span>鉴别结果未出，暂时无法查看报告，请稍后~</span>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { ImagePreview } from "vant";
import { addVisitNums, fetchAppraisalJDReport } from "@/common/api/appraisal.js";
export default {
  data() {
    return {
      loading: true,
      isResult: false,
      jdReportDetail: {},
    };
  },
  computed: {
    appraiserDate() {
      if(!(this.jdReportDetail && this.jdReportDetail.appraisalResultTime)) return {year: "", month: "", day: ""}

      const [year, month, day] = this.jdReportDetail.appraisalResultTime.split(" ")[0].split("-")
      return {year, month, day}
    },
    kindBrandSeries() {
      let kindName = this.jdReportDetail.kindName || "-";
      let brandName = this.jdReportDetail.brandName || "-";
      let seriesName = this.jdReportDetail.seriesName || "-";
      let specifications = this.jdReportDetail.specifications || "-";

      return `${kindName} / ${brandName} / ${seriesName} / ${specifications}`;
    },
    imageList() {
      return this.jdReportDetail.identificationImage.slice(0,6).map(it => it)
    }
  },
  created() {
    console.log(this.$route.params, "this.$router.params");
  },
  
  mounted() {
    this.getReport();
  },
  created() {
    // 暂时配合后端设计思路，不校验结果
    // addVisitNums({ qrCode: this.$route.params.code })
  },
  methods: {
    dateFormat() {
      return dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
    },
    async getReport() {
      const { code: qrCode } = this.$route.params;
      try {
        // 暂时配合后端设计思路，不校验结果
        await addVisitNums({ qrCode })
        fetchAppraisalJDReport({ qrCode })
          .then(async (res) => {
            if (res.errorMsg === "Success") {
              if (res.result) {
                this.isResult = true;
                this.jdReportDetail = res;
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        
      }
    },
    previewImage(startPosition) {
      let images = this.imageList
      ImagePreview({ images, startPosition });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background: #f5f6fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  .header {
    height: 181 * 2px;
    width: 100%;
    .bg {
      width: 100%;
      height: 100%;
    }
  }
  .topcard {
    background-color: #fff;
    border-radius: 16px;
    padding: 26px 0 24px 28px;
    box-sizing: border-box;
    width: 351 * 2px;
    margin-top: 32px;
    display: flex;
    flex-direction: column;

    .zhi {
      height: 40px;
      width: 280px;
      margin-bottom: 6px;
    }

    span {
      color: #b4b5be;
      font-size: 20px;
      font-weight: 400;
      line-height: 28px;
      letter-spacing: 2px;

      &:not(:last-of-type) {
        margin-bottom: 6px;
      }
    }
  }
  .content {
    position: relative;
    width: 351 * 2px;
    margin-top: 32px;
    border-radius: 16px;
    background: #ffffff;
    .title {
      margin-top: 12 * 2px;
      display: flex;
      justify-content: center;
      img {
        width: 214 * 2px;
        height: 33 * 2px;
      }
    }
    .main {
      width: 319 * 2px;
      margin: 0 auto;
      .mb24 {
        margin-bottom: 24px;
      }
      .mb36 {
        margin-bottom: 36px;
      }
      .mark {
        width: 140 * 2px;
        height: 160 * 2px;
        position: absolute;
        top: 69 * 2px;
        left: 211 * 2px;
      }
      .item {
        margin-top: 12 * 2px;
        .label {
          display: flex;
          align-items: center;
          .icon {
            display: inline-block;
            width: 3 * 2px;
            height: 12 * 2px;
            background: #203c85;
          }
          .des-name {
            margin-left: 4 * 2px;
            font-size: 12 * 2px;
            color: #b4b5be;
          }
        }
        .value {
          margin-top: 6 * 2px;
          margin-left: 8 * 2px;
          .true-value {
            font-weight: 600;
            font-size: 14 * 2px;
            color: #3a3d44;
            img {
              background-color: #e9e9e9;
              width: 91 * 2px;
              height: 91 * 2px;
              border-radius: 8 * 2px;
              object-fit: contain;
              margin-right: 15 * 2px;
              margin-bottom: 15 * 2px;
            }
            img:nth-child(3n) {
              margin-right: 0;
            }
          }
        }
      }
    }
    .desc {
      margin-bottom: 11 * 2px;
      font-size: 12 * 2px;
      color: #b4b5be;
      text-align: center;
    }
  }
  .footer {
    margin-top: 12 * 2px;
    font-size: 12 * 2px;
    color: #b4b5be;

    &::after {
      content: "";
      display: flex;
      height: 60px;
    }
  }
}
.no-result {
  display: flex;
  justify-content: center;
  align-items: center;
  .van-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .empty{
    margin-top: 200px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #333;
  }

  .null-img{
    width: 400px;
  }
}
</style>
